import { useNavigate, useLocation, createSearchParams } from "react-router-dom";
import { Form, SubmitButton } from "./FormControl";
import { useDispatch } from "react-redux";
import userSlice from "../../Store/userSlice";
import userFieldsSlice from "../../Store/userFieldsSlice";
import { useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import LabelSession from "../../Store/LabelSession";
import {
  requestOptions,
  VIPSDataServiceURL,
  Table as TableType,
  MenuURL,
} from "../../Constants/GlobalConstant";
import Grid from "@mui/material/Grid";
import SessionArray from "../../Store/SessionArray";
import SchemaObject from "../../Store/SchemaObject";
import { ScrollToErrors } from "./ScrollToError";
import { schemaValidation } from "../../CommonFuntion/SchemaValidation";
import Chip from "@mui/material/Chip";
import { getMessage } from "../../CommonFuntion/messages";
import {
  initForm,
  removeSeperatorValue,
  RemoveCheckBoxValue,
  parseCSV,
  SaveSessionData,
  saveSchemaObjectLocal,
  fetchResult2,
  executeLogic,
  fetchResult,
  combineCSVData,
  openPopup,
  getFilteredData,
  handleUpload,
  handleFileUpload,
  onSubmit,
  onSubmitOCC,
} from "../../CommonFuntion/indexHelper";
import {
  RedirectToSourceLoginIfSessionExpired,
  getUserSessionData,
  deleteUserSessionData,
  deleteUserLabelSessionData,
  getLabelTypeForSession,
} from "../../CommonFuntion/CheckSession";
import { sessionCache } from "../../CommonFuntion/sessionCache";
import { callOCCProfileAPI } from "../../CommonFuntion/callOCCAPI";
import { Alert } from "@mui/material";
import LoadingOverlay from "./LoadingOverlay";
import SchemaNotFoundAlert from "./SchemaNotFoundAlert";
import DynamicFormElements from "./DynamicFormElements";
import ediMockResponse from "../../Reponse.json";
import Button from "@mui/material/Button";
import { validateELCNoDuplicates, buildELCDuplicateErrors } from "./DynamicFieldRenderer";

import {
  GetSystemParameterValueByName,
  GetTescoMapping,
  getUserDivisions,
  getStoreInfo,
  GetEdiCatalogData,
  VerifyUserSecurityAccess,
} from "../../CommonFuntion/SchemaAPICalls";
import SnackbarAlert from "./SnackbarAlert";
import CancelOrderButton from "./CancelOrderButton";

// ── EDI Mock Toggle ──────────────────────────────────────────────────
// Set useMock to true to use local mock data (src/Reponse.json) instead
// of the backend proxy.  Flip to false once the .NET
// GetEdiCatalogData endpoint is deployed.
export const ediConfig = { useMock: false };
// ─────────────────────────────────────────────────────────────────────

// Default EDI field mappings — used when the system parameter config
// does not include a "fieldMappings" object.  Keeps backward compat.
const DEFAULT_EDI_FIELD_MAPPINGS = {
  ITEM: ["LABEL REF", "Label Ref", "LABEL_REF"],
  SIZE: ["SIZE_ID", "Size ID", "SIZEID"],
  TOTALQTY: ["TOTAL_QTY", "Total Qty", "TOTALQTY", "QTY"],
  PRODUCTTYPE: ["PRODUCT_TYPE", "Product Type", "PRODUCTTYPE"],
  SUPPLIERCODE: ["SUPPLIER_CODE", "Supplier Code", "SUPPLIERCODE"],
  PRODUCTIONORDERNUMBER: ["ORDER_NUMBER", "Production Order Number", "PRODUCTIONORDERNUMBER"],
  CAMPAIGN: ["SEASON", "Campaign"],
};

// Default filter-field mapping — maps API parameter names to Formik field names
const DEFAULT_EDI_FILTER_FIELDS = {
  productionOrderNumber: "ORDER_NUMBER",
  campaign: "SEASON",
  supplierCode: "SUPPLIER_CODE",
};

// Default editable fields — fieldNames that remain editable when EDI readonly
// mode is active. Everything else is disabled. Configurable via
// "editableFields" in the system parameter config object.
// Use actual field names (e.g. "QTY", "Size Qty") not prefixes.
const DEFAULT_EDI_EDITABLE_FIELDS = [];

const OEForm = (post) => {
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [formData, setFormData] = useState([{}]);
  const [val, setVal] = useState([]);
  const [val2, setVal2] = useState([]);

  const [pageId, setPageId] = useState(0);
  const [pageName, setPageName] = useState("");
  const [childOpt, setChildOpt] = useState();
  const [LLIValue, setLLIValue] = useState("");
  const [catTabData, setCatTabData] = useState({});
  const [catTabData2, setCatTabData2] = useState({});
  const [pageSequence, setPageSequence] = useState(0);
  const [childPages, setChildPages] = useState(false);

  let user = useSelector((state) => state.user);
  const userFields = useSelector((state) => state.userFields);
  const [labels, setLabels] = useState([]);

  const [labelsCount, setLabelsCount] = useState(0);
  const [labelsCount2, setLabelsCount2] = useState(0);
  const [labelArray2, setLabelArray] = useState([]);
  const [objetArray, setObjetArray] = useState([]);
  let sessionArray = [];

  const searchParams = new URLSearchParams(location.search);
  const [isLoading, setIsLoading] = useState(false);
  const [copyOrderData, setCopyOrderData] = useState({});
  const [labelReference, setlabelReference] = useState("");
  const [schemaData, setSchemaData] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [mapTableItemID, setMapTableItemID] = useState(null);
  const [tableItemID, setTableItemID] = useState();
  const [mandatoryByLabelName, setMandatoryByLabelName] = useState();
  const [disableByLabelName, setDisableByLabelName] = useState();
  const [resetELCList, setResetELCList] = useState(false);
  const [ELLValue, setELLValue] = useState("");
  const [ELLSchemaItem, setELLSchemaItem] = useState(null);
  const [pageChange, setPageChange] = useState(false);
  const [schemaNotFound, setSchemaNotFound] = useState(false);
  const [csvEnableSchemas, setCsvEnableSchemas] = useState([]);
  const [csvUplaodEnabled, setCsvUplaodEnabled] = useState(false);
  const [multipleCsvUplaodEnabled, setMultipleCsvUplaodEnabled] =
    useState(false);
  const [csvFileNameStartLatters, setCsvFileNameStartLatters] = useState([]);
  const [csvFileNameEndWith, setCsvFileNameEndWith] = useState([]);
  const [regexString, setRegexString] = useState("");
  const [selectedTabs, setSelectedTabs] = useState(() => {
    const savedTabs = localStorage.getItem("selectedTabs");
    return savedTabs ? JSON.parse(savedTabs) : [];
  });
  const fileInput1Ref = useRef(null);
  const fileInput2Ref = useRef(null);
  const [uploadedFileTesco, setUploadedFileTesco] = useState(false);
  const [toggleTescoFileUploaded, setToggleTescoFileUploaded] = useState(false);
  const [tescoFiledMapping, setTescoFiledMapping] = useState({});
  const [divisionID, setDivisoinID] = useState("");
  const [ELCDropDown, setELCDropDown] = useState();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  // New: control CancelOrderButton visibility
  const [showCancelButton, setShowCancelButton] = useState(true);
  // EDI schema configuration — null when EDI is not enabled for this schema,
  // otherwise an object from the system parameter with all dynamic settings:
  // { schemaName, brandCode, buttonText, apiUrlParam, subscriptionKeyParam,
  //   filterFields, fieldMappings }
  const [ediSchemaConfig, setEdiSchemaConfig] = useState(null);
  // Factory-Division cascading config from system parameter
  const [factoryDivisionConfig, setFactoryDivisionConfig] = useState(null);
  // Derived: EDI button visible when config exists
  const showEDIButton = ediSchemaConfig !== null;
  // EDI API URL and subscription key (fetched based on config param names)
  const [ediApiUrl, setEdiApiUrl] = useState("");
  const [ediSubscriptionKey, setEdiSubscriptionKey] = useState("");
  // New: store mocked EDI response data
  const [ediData, setEdiData] = useState([]);
  // New: when EDI data is loaded, make all fields read-only except QTY
  const [ediReadonlyMode, setEdiReadonlyMode] = useState(false);
  // New: EDI loading spinner and table visibility
  const [ediLoading, setEdiLoading] = useState(false);
  const [ediTableVisible, setEdiTableVisible] = useState(true);
  const [
    allow100PercentFibreWithourGarment,
    setAllow100PercentFibreWithourGarment,
  ] = useState(false);
  const [catalogueChildOptn, SetcatalogueChildOptn] = useState();
  let user_id = "";
  if (typeof post.post !== "undefined") {
    // Normalize paxWebSessionStrings to an array to avoid forEach on undefined
    const pax = Array.isArray(post.post.paxWebSessionStrings)
      ? post.post.paxWebSessionStrings
      : [];
    sessionArray = pax;
    localStorage.setItem("sessionArray", JSON.stringify(sessionArray));

    pax.forEach(function (item) {
      if (item.Key == "user_id") {
        user_id = item.Value;
      }
    });
  }

  if (typeof sessionArray !== "undefined") {
    sessionArray = JSON.parse(localStorage.getItem("sessionArray"));
  }
  let labelSessionArray = [];
  let schema_id = "";
  let occ_profile = "";
  let prod_loc_occ = "";
  let schema_name = "";
  const [schemaName, setSchemaName] = useState("");
  sessionArray?.forEach(function (item) {
    if (item.Key == "LabelList") {
      const jsonData = JSON.parse(item.Value);

      const occLabelList = jsonData.OCCLabelList;
      schema_name = jsonData.SchemaName;
      occ_profile = jsonData.OccProfile;
      prod_loc_occ = jsonData.OccProdLocation;
      const distinctValues = [
        ...new Set(occLabelList.map((item) => item.LabelReference)),
      ];
      labelSessionArray = distinctValues;
    }
    if (item.Key == "schema_id") {
      schema_id = item.Value;
    }
    if (item.Key == "schema_name") {
      schema_name = item.Value;
    }
  });

  if (
    localStorage.getItem("firstPageID") === null ||
    localStorage.getItem("firstPageID") === undefined
  ) {
    localStorage.setItem(
      "firstPageID",
      JSON.stringify(searchParams.get("PageID"))
    );
    localStorage.setItem(
      "firstLabel",
      JSON.stringify(searchParams.get("label"))
    );
  }
  let divisionId = "";
  let uniqueProductIds = [];
  var orderInprogess = true;

  // Derive sessionObjectId: use label type (e.g., "V000005") from labelSessionArray
  // instead of label name (e.g., "SKU-STICK-G") for session storage key
  const sessionObjectId =
    getLabelTypeForSession(searchParams.get("label"), labelSessionArray) ||
    searchParams.get("PageID");

  useEffect(() => {
    // Reset per-table totals when the form mounts or route/search changes
    if (typeof window !== "undefined") {
      window.__tableTotals = {};
    }
    return () => {
      if (typeof window !== "undefined") {
        window.__tableTotals = {};
      }
    };
  }, [location.search.toString()]);

  useEffect(() => {
    let isMounted = true;
    
    // Fetch system parameters once at the start
    const clearSessionSchemasPromise = !searchParams.get("OCC")
      ? GetSystemParameterValueByName("REACT_APP_CLEAR_SESSION_DATA_FOR_SCHEMAS")
      : Promise.resolve([]);
    // New: EDI API integration enabled schemas
    const ediIntegrationSchemasPromise = !searchParams.get("OCC")
      ? GetSystemParameterValueByName("REACT_APP_EDI_API_INTEGRATION_SCHEMAS")
      : Promise.resolve([]);
    // New: Factory-Division cascading config
    const factoryDivisionConfigPromise = !searchParams.get("OCC")
      ? GetSystemParameterValueByName("REACT_APP_FACTORY_DIVISION_SCHEMAS")
      : Promise.resolve([]);
    
    const cancelButtonStoresPromise = GetSystemParameterValueByName(
      "REACT_APP_DONT_SHOW_CLEAR_ALL_BUTTON_FOR_RBO"
    ).catch(() => []);

    // Determine cancel button visibility
    const storeGrp = searchParams?.get?.("store_grp");
    if (typeof storeGrp === "string" && storeGrp) {
      cancelButtonStoresPromise.then((data) => {
        if (!isMounted) return;
        const dontShowForStores = Array.isArray(data) ? data : [];
        setShowCancelButton(!dontShowForStores.includes(storeGrp));
      });
    } else {
      setShowCancelButton(true);
    }

    getStoreInfo(searchParams.get("store_grp")).then((storeInfo) => {
      if (
        storeInfo.select_Division === "Y" &&
        !searchParams.get("SelectedDivision") &&
        !searchParams.get("OrderID")
      ) {
        getUserDivisions(user_id).then((userDivisions) => {
          if (userDivisions.length > 1) {
            navigate({
              pathname:
                "/" + process.env.REACT_APP_ORDERING_PATH + "/SelectDivision",
              search: createSearchParams(location.search).toString(),
            });
          }
        });
      }

      getUserSessionData(
        user_id,
        sessionObjectId
      ).then((data2) => {
        if (!isMounted) return;
        
        for (var key in data2) {
          if (key === "firstPageID") {
            // firstPageID stays in localStorage — it is a small navigational value
            // read by many unrelated components
            localStorage.setItem(key, JSON.stringify(data2[key]));
          } else {
            sessionCache.set(key, data2[key]);
          }
        }

        setPageChange(true);
        setSchemaNotFound(false);
        RedirectToSourceLoginIfSessionExpired(
          user_id,
          searchParams.get("session_id"),
          searchParams.get("OCC"),
          orderInprogess
        );
        sessionArray.forEach(function (item) {
          if (item.Key == "division_id") {
            divisionId = item.Value;
            setDivisoinID(item.Value);
          }
          if (item.Key == "user_id") {
            user_id = item.Value;
          }
          if (item.Key == "schema_id") {
            schema_id = item.Value;
          }
          if (item.Key == "schema_name") {
            setSchemaName(item.Value);
          }
        });
        window.scrollTo(0, 0);
        setIsLoading(true);
      
        if (!searchParams.get("OCC")) {
          var myItem = localStorage.getItem("sessionArray");
          var firstPageID = localStorage.getItem("firstPageID");
          var firstLabel = localStorage.getItem("firstLabel");
          // SU key now lives in sessionCache, not localStorage
          var firstPageData = sessionCache.get(
            "SU" + JSON.parse(firstPageID) + user_id + "saveUser"
          );

          // Use the cached promise instead of making a new API call
          clearSessionSchemasPromise.then((data) => {
            if (!isMounted) return;
            
            if (!searchParams.get("label")) {
              localStorage.removeItem("firstPageID");
              localStorage.removeItem("firstLabel");
            }
            if (
              data.some((item) => item === schema_name) 
            ) {
              if (!searchParams.get("Amend")) {
                localStorage.clear();
                sessionCache.clear();
                if (searchParams.get("label")) {
                  localStorage.setItem("sessionArray", myItem);
                  localStorage.setItem("firstPageID", firstPageID);
                  localStorage.setItem("firstLabel", firstLabel);
                  // Restore first-page SU data to sessionCache (already a parsed object)
                  if (firstPageData) {
                    sessionCache.set(
                      "SU" + JSON.parse(firstPageID) + user_id + "saveUser",
                      firstPageData
                    );
                  }
                }

                deleteUserSessionData(
                  user_id,
                  sessionObjectId
                ).then(() => {
                  if (!isMounted) return;

                  var jsonObjectId = "LabelList";
                  deleteUserLabelSessionData(user_id, jsonObjectId).then(() => {
                    if (!isMounted) return;

                    getUserSessionData(
                      user_id,
                      sessionObjectId
                    ).then((data2) => {
                      if (!isMounted) return;

                      for (var key in data2) {
                        if (key === "firstPageID") {
                          localStorage.setItem(key, JSON.stringify(data2[key]));
                        } else {
                          sessionCache.set(key, data2[key]);
                        }
                      }
                    });
                  });
                });
              }
            }
          });
          // Determine EDI button visibility and load config based on schema name
          ediIntegrationSchemasPromise.then((data) => {
            if (!isMounted) return;
            const list = Array.isArray(data) ? data : [];
            const normalizedSchemaName = String(schema_name || "").trim().toLowerCase();
            // Support both legacy string array and new config-object array
            const matchedConfig = list.find((item) => {
              if (typeof item === "string") {
                return item.trim().toLowerCase() === normalizedSchemaName;
              }
              if (item && typeof item === "object" && item.schemaName) {
                return String(item.schemaName).trim().toLowerCase() === normalizedSchemaName;
              }
              return false;
            });
            if (matchedConfig) {
              // Normalize: if legacy string, convert to minimal config object
              const config = typeof matchedConfig === "string"
                ? { schemaName: matchedConfig }
                : matchedConfig;
              setEdiSchemaConfig(config);
              setEdiReadonlyMode(true);
              // Read API URL and subscription key directly from config
              if (config.apiUrl) setEdiApiUrl(config.apiUrl);
              if (config.subscriptionKey) setEdiSubscriptionKey(config.subscriptionKey);
            } else {
              setEdiSchemaConfig(null);
            }
          });
          // Resolve Factory-Division cascading config for the current schema
          factoryDivisionConfigPromise.then((data) => {
            if (!isMounted) return;
            const list = Array.isArray(data) ? data : [];
            const normalizedSchemaName = String(schema_name || "").trim().toLowerCase();
            const matched = list.find((item) =>
              item && typeof item === "object" && item.schemaName &&
              String(item.schemaName).trim().toLowerCase() === normalizedSchemaName
            );
            if (matched) {
              setFactoryDivisionConfig(matched);
              localStorage.setItem("factoryDivisionConfig", JSON.stringify(matched));
            } else {
              setFactoryDivisionConfig(null);
              localStorage.removeItem("factoryDivisionConfig");
            }
          });
        }
  

        if (labelSessionArray.length > 0) {
          var selectedLabel;
          var pageName;
          var labelRef;
          if (labelSessionArray.length > 1) {
            selectedLabel =
              labelSessionArray[labelSessionArray.length - 1].split("[");

            pageName = selectedLabel[1].replace("]", "");
            labelRef = selectedLabel[0].replace("]", "");
            setLabelsCount2(labelSessionArray.length - 1);
          } else {
            selectedLabel = labelSessionArray[0].split("[");
            pageName = selectedLabel[1].replace("]", "");
            labelRef = selectedLabel[0].replace("]", "");
          }
          setPageName(pageName);
        }
        executeLogic(
          searchParams,
          fetchResult2,
          fetchResult,
          pageName,
          user,
          setVal,
          setVal2,
          setTableItemID,
          setFormData,
          initForm,
          setPageId,
          setPageSequence,
          setChildPages,
          setIsLoading,
          setSchemaNotFound,
          setDisableByLabelName,
          setMandatoryByLabelName,
          setSelectedOption,
          setMapTableItemID,
          labelRef,
          labelsCount2,
          labelSessionArray,
          user_id,
          copyOrderData,
          labelReference,
          divisionId,
          VIPSDataServiceURL,
          requestOptions,
          navigate,
          uniqueProductIds,
          pageSequence,
          setlabelReference,
          setLabelsCount2,
          dispatch,
          LabelSession,
          setSchemaData,
          setCopyOrderData
        );
      });
    });
    
    return () => { isMounted = false; };
  }, [location.search.toString()]);
  useEffect(() => {
    localStorage.setItem("selectedTabs", JSON.stringify(selectedTabs));
  }, [selectedTabs]);
  useEffect(() => {
    if (searchParams.get("store_grp") == "TES") {
      GetTescoMapping(pageName,schema_name).then((data) => {
        setTescoFiledMapping(data);
        setUploadedFileTesco(true);
      });
    }
  }, [pageName]);
  useEffect(() => {
    var isSchemaEnabled = "";
    sessionArray.forEach(function (item) {
      if (item.Key == "division_id") {
        divisionId = item.Value;
      }
    });
    GetSystemParameterValueByName("REACT_APP_CSV_UPLOAD_ENABLED_SCHEMAS").then(
      (data) => {
        setCsvEnableSchemas(data);
        isSchemaEnabled = data.some((item) => item.schemaName === schema_name);
        setCsvUplaodEnabled(isSchemaEnabled);
        setMultipleCsvUplaodEnabled(
          data.some(
            (item) =>
              item.schemaName === schema_name && item.multipleCSVUploadEnable
          )
        );
        setCsvFileNameStartLatters(
          data.find((item) => item.schemaName === schema_name)
            ?.fileNameStartWith
        );
        setCsvFileNameEndWith(
          data.find((item) => item.schemaName === schema_name)?.fileNameEndWith
        );
        setRegexString(
          data.find((item) => item.schemaName === schema_name)?.regexString
        );
      }
    );
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    // GetSystemParameterValueByNameTextFormat(
    //   "ALLOW_100_PERCENT_FIBRE_WITHOUT_GARMENT_" + searchParams.get("store_grp")
    // ).then((data) => {
    //   if (data.length > 0) {
    //     if (data === "Y") {
    //       setAllow100PercentFibreWithourGarment(true);
    //     }
    //   }
    // });
  }, []);

  const [details2, setDetails] = useState(null);
  const handleDropdownChange = (value, LableTableMapPart) => {
    setSelectedOption(value);

    const prefix = value.split("[")[0];
    
    const partWithDropdownValue = LableTableMapPart.split("|").find((part) =>
      part.startsWith(prefix)
    );
    
    if(!(partWithDropdownValue === undefined))
    {
      const number = prefix ? partWithDropdownValue.split("#")[1] : null;
      setMapTableItemID(number);
    }
    setMandatoryByLabelName(prefix);
    setDisableByLabelName(prefix);
  };

  const handleResetELCList = (value) => {
    setResetELCList(value);
  };

  const handleELLValue = (value) => {
    setELLValue(value);
  };

  const handleELLVSchemaItem = (item) => {
    setELLSchemaItem(item);
  };
  // Helper function to handle bind result logic
  function handleBindResult({ details, sizeChart, fileType, orderType }) {
    // Add logic to split sizeChart and update details if needed
    if (typeof sizeChart === 'string' && sizeChart.indexOf('|') !== -1) {
      var headerInfo = sizeChart.split('|');
      sizeChart = headerInfo[3];
      // If details is an object with numeric keys, add TESCONO, EQOS, COO to each item
      if (details && typeof details === 'object' && !Array.isArray(details)) {
        Object.keys(details).forEach(key => {
          if (typeof details[key] === 'object' && details[key] !== null) {
            details[key] = {
              ...details[key],
              TESCONO: headerInfo[0],
              EQOS: headerInfo[1],
              COO: headerInfo[2]
            };
          }
        });
      } else if (Array.isArray(details)) {
        details = details.map(item => ({
          ...item,
          TESCONO: headerInfo[0],
          EQOS: headerInfo[1],
          COO: headerInfo[2]
        }));
      }
    }
    console.log(details, sizeChart, fileType, orderType);
    setDetails({ details, sizeChart, fileType, orderType });
    setUploadedFileTesco(true);
    if (toggleTescoFileUploaded) {
      setToggleTescoFileUploaded(false);
    } else {
      setToggleTescoFileUploaded(true);
    }
    initForm(
      regexString,
      searchParams,
      schemaData.schemaPageFields,
      uniqueProductIds,
      searchParams.get("OrderID"),
      copyOrderData,
      labelReference,
      user_id,
      setFormData,
      null,
      userSelection,
      schemaName,
      uploadedFileTesco,
      details,
      tescoFiledMapping,
      sizeChart,
      fileType,
      orderType,
      pageName,
      ELCDropDown,
      setELCDropDown,
      searchParams.get("schema_id"),
      formData,
      ediReadonlyMode
    );
  }

  window.BindResultValue = (details, labeltype, orderType) => {
    // labeltype is not used, but kept for compatibility
    handleBindResult({ details, sizeChart: undefined, fileType: undefined, orderType });
  };
  window.bindResult = (details, sizeChart, fileType, orderType) => {
    handleBindResult({ details, sizeChart, fileType, orderType });
  };

  function saveUserLocal(arr) {
    let user_id = "";
    sessionArray.forEach(function (item) {
      if (item.Key == "user_id") {
        user_id = item.Value;
      }
    });

    var index;
    if (searchParams.get("OCC")) {
      let newArray = labelSessionArray.map((element) => {
        let parts = element.split("[");
        return parts[0]; // Removes the trailing ']'
      });
      index = newArray.indexOf(searchParams.get("label")); // 1
      index = index + 1;
    } else {
      index = labelsCount;
    }

    sessionCache.set("SU" + sessionObjectId + user_id + "saveUser", arr);
    if (searchParams.get("OCC")) {
      callOCCProfileAPI(true, prod_loc_occ, occ_profile, schema_name);
    }
  }

  const [csvData, setCsvData] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  const [uploaded, setUploaded] = useState(true);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [combinedData, setCombinedData] = useState(null);
  const [userSelection, setUserSelection] = useState(false);
  const openPopup = () => {
    var sessionId = searchParams.get("session_id");
    var PageID = searchParams.get("PageID");
    var labelref = searchParams.get("label");

    let processFile = "ProcessFile.aspx";
    switch (schemaName) {
      case "Tesco Disney RFID/NON RFID":
        processFile = "ProcessFile_DRFID.aspx";
        break;
      case "TESCO RFID/NON RFID":
        processFile = "ProcessFile_RFID.aspx";
        break;
      case "TESCO RFID/NON RIFD":
        processFile = "ProcessFile_RFID.aspx";
        break;
      case "Paper/Stickers":
        processFile = "ProcessFile_PaperStickers.aspx";
        break;
      case "VIPS Disney PFL":
        processFile = "ProcessFile_DPFL.aspx";
        break;
      default:
        processFile = processFile;
        break;
    }
    window.open(
      `${MenuURL}` +
        `/Pages/orders/${processFile}?session_id=${sessionId}&` +
        `PageID=` +
        PageID +
        `&labelref=` +
        labelref,
      "popupWindow",
      "width=600,height=400"
    );
  };

  // EDI click: expects filters from Formik values (no DOM access)
  async function handleEDIClick(filters, formikValues) {

    // Validate mandatory non-table fields before proceeding (same as form submit)
    if (formikValues && val?.length > 0) {
      const allErrors = schemaValidation(
        formikValues,
        val,
        mandatoryByLabelName,
        mapTableItemID,
        selectedOption,
        tableItemID,
        selectedTabs,
        csvUplaodEnabled
      );
      // Keep only non-table field errors (table errors are arrays or "_Label" suffixed keys)
      const nonTableErrors = Object.keys(allErrors).filter((key) => {
        return typeof allErrors[key] === "string" && !key.endsWith("_Label") && !key.endsWith("_Total_Label");
      });
      if (nonTableErrors.length > 0) {
        const fieldNames = nonTableErrors.join(", ");
        setSnackbarMessage(`Please fill mandatory fields before loading EDI data: ${fieldNames}`);
        setOpenSnackbar(true);
        return;
      }
    }

    // Show loading, hide table while data maps
    setEdiLoading(true);
    setEdiTableVisible(false);

    // Read dynamic config (all values from system parameter, with defaults)
    const brandCode = ediSchemaConfig?.brandCode || "ZARA";
    const configFieldMappings = ediSchemaConfig?.fieldMappings || DEFAULT_EDI_FIELD_MAPPINGS;

    // Build filter values dynamically from whatever was passed by EDIButtonInline
    const trimmedFilters = {};
    Object.entries(filters || {}).forEach(([key, value]) => {
      trimmedFilters[key] = String(value || "").trim();
    });

    try {
      let responseData;
      if (ediConfig.useMock) {
        // Use local mock data until .NET backend proxy is ready
        responseData = ediMockResponse;
      } else {
        // Validate that we have the EDI API URL (only needed for real API calls)
        if (!ediApiUrl) {
          setSnackbarMessage("EDI API URL is not configured. Please check apiUrl in REACT_APP_EDI_API_INTEGRATION_SCHEMAS system parameter.");
          setOpenSnackbar(true);
          setEdiLoading(false);
          setEdiTableVisible(true);
          return;
        }
        // Call EDI API through VIPS backend proxy (avoids CORS)
        // Determine which API URL to use: tester URL if user has security access
        let resolvedApiUrl = ediApiUrl;
        const testerApiUrl = ediSchemaConfig?.testerApiUrl;
        const testerSecurityId = ediSchemaConfig?.testerSecurityId;
        if (testerApiUrl && testerSecurityId && user_id) {
          try {
            const hasTesterAccess = await VerifyUserSecurityAccess(user_id, testerSecurityId);
            if (hasTesterAccess) {
              resolvedApiUrl = testerApiUrl;
            }
          } catch (e) {
            // On error, fall back to default apiUrl
            console.warn("[EDI] Tester access check failed, using default URL", e);
          }
        }
        responseData = await GetEdiCatalogData({
          ediApiUrl: resolvedApiUrl,
          subscriptionKey: ediSubscriptionKey,
          brandCode,
          filters: trimmedFilters,
        });
      }

      // Extract records array from the wrapped response object
      const allData = Array.isArray(responseData?.records) ? responseData.records : [];
      if (allData.length === 0) {
        // Clear previous EDI data so stale results don't remain on screen
        setEdiData([]);
        // Re-initialize the form to clear table rows from previous EDI load
        initForm(
          regexString,
          searchParams,
          schemaData.schemaPageFields,
          uniqueProductIds,
          searchParams.get("OrderID"),
          copyOrderData,
          labelReference,
          user_id,
          setFormData,
          null,
          userSelection,
          schemaName,
          false, // no file uploaded
          null,  // empty details
          null,
          undefined, // sizeChart
          undefined, // fileType
          undefined, // orderType
          pageName,
          ELCDropDown,
          setELCDropDown,
          searchParams.get("schema_id"),
          formData,
          ediReadonlyMode
        );
        setSnackbarMessage(responseData?.msg || "No EDI data found for the given filters.");
        setOpenSnackbar(true);
        setEdiLoading(false);
        setEdiTableVisible(true);
        return;
      }

      setEdiData(allData);

      // Map into details with UPPERCASE keys for consistent fieldName matching
      const details = allData.map((item) => {
        const row = item?.catData || {};
        const upperRow = {};
        Object.keys(row).forEach((k) => {
          upperRow[k.toUpperCase()] = String(row[k] ?? "");
        });
        return upperRow;
      });

      // Split long values (> 250 chars) into chunks, mirroring parseCSV logic
      const splitDetails = details.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((header) => {
          const value = String(row[header] ?? "");
          if (value.length > 250) {
            // First 250 chars go in original header
            newRow[header] = value.substring(0, 250);
            // Remaining chunks go in header-2, header-3, etc.
            let start = 250;
            let chunkIndex = 2;
            while (start < value.length) {
              const end = Math.min(start + 250, value.length);
              newRow[`${header}-${chunkIndex}`] = value.substring(start, end);
              start = end;
              chunkIndex++;
            }
          } else {
            newRow[header] = value !== "" ? value : row[header];
          }
        });
        return newRow;
      });

      // Build mapping: UPPERCASE source keys → target schema fieldNames
      // Start with identity mapping (every key maps to itself)
      const sampleRow = splitDetails[0] || {};
      const mapping = Object.keys(sampleRow).reduce((acc, key) => {
        acc[key] = key;
        return acc;
      }, {});
      // Apply configurable special mappings (from system parameter or defaults)
      Object.entries(configFieldMappings).forEach(([sourceKey, targetFields]) => {
        mapping[sourceKey.toUpperCase()] = Array.isArray(targetFields) ? targetFields : [targetFields];
      });

      // Wrap setFormData so that when initForm internally calls it,
      // non-table filter values from formikValues are automatically restored.
      // This is necessary because initForm is async (calls setFormData inside
      // a .then() callback) so a separate restore after initForm() would race.
      const wrappedSetFormData = (newData) => {
        setFormData((prev) => {
          const base = typeof newData === "function" ? newData(prev) : newData;
          if (!formikValues || typeof formikValues !== "object") return base;
          const restored = Array.isArray(base) ? { ...base[0] } : { ...base };
          Object.keys(formikValues).forEach((key) => {
            if (!Array.isArray(formikValues[key])) {
              restored[key] = formikValues[key];
            }
          });
          return Array.isArray(base) ? [restored] : restored;
        });
      };

      initForm(
        regexString,
        searchParams,
        schemaData.schemaPageFields,
        uniqueProductIds,
        searchParams.get("OrderID"),
        copyOrderData,
        labelReference,
        user_id,
        wrappedSetFormData,
        null,
        userSelection,
        schemaName,
        true, // uploadedFileTesco: reuse processCostDetails path for fieldName-based mapping
        splitDetails,
        mapping, // use UPPERCASE-based mapping with special cases
        undefined, // sizeChart
        undefined, // fileType
        "EDI", // orderType
        pageName,
        ELCDropDown,
        setELCDropDown,
        searchParams.get("schema_id"),
        formData,
        true // EDI load → always pass true so initForm uses details.length
      );
      setSnackbarMessage(`${responseData?.msg} (${responseData?.count} item(s))`);
      setOpenSnackbar(true);
      // Enable read-only mode for all fields except QTY after EDI load
      setEdiReadonlyMode(true);
      // Show the table now that data is mapped
      setEdiLoading(false);
      setEdiTableVisible(true);
    } catch (e) {
      console.error("[EDI] API call failed:", e);
      // Clear previous EDI data so stale results don't remain on screen
      setEdiData([]);
      setSnackbarMessage(`Failed to load EDI data: ${e.message}`);
      setOpenSnackbar(true);
      setEdiLoading(false);
      setEdiTableVisible(true);
    }
  }


  return (
    <Grid item id="content">
      <div>
        <LoadingOverlay
          isLoading={isLoading}
          message={getMessage("orderProcessing")}
        />

        <Form
          enableReinitialize={true}
          initialValues={formData}
          onSubmit={
            labelSessionArray.length > 0 && searchParams.get("OCC")
              ? (values) =>
                  onSubmitOCC({
                    values,
                    sessionArray,
                    setLabels,
                    setLabelsCount,
                    setObjetArray,
                    setLabelArray,
                    dispatch,
                    LabelSession,
                    labelArray2,
                    objetArray,
                    user,
                    userFields,
                    saveUserLocal,
                    searchParams,
                    labels,
                    labelsCount2,
                    labelSessionArray,
                    val,
                    val2,
                    setLabelsCount2,
                    setPageId,
                    setIsLoading,
                    navigate,
                    TableType,
                    removeSeperatorValue,
                    saveSchemaObjectLocal,
                    SchemaObject,
                    getMessage,
                    setSnackbarMessage,
                    setOpenSnackbar,
                    childPages,
                    pageSequence,
                    setPageName,
                    setlabelReference,
                    VIPSDataServiceURL,
                    requestOptions,
                    location,
                    createSearchParams,
                  })
              : (values) =>
                  onSubmit({
                    values,
                    csvUplaodEnabled,
                    selectedTabs,
                    setSnackbarMessage,
                    getMessage,
                    setOpenSnackbar,
                    getFilteredData,
                    setResetELCList,
                    sessionArray,
                    pageSequence,
                    childPages,
                    val,
                    setLabels,
                    setLabelsCount,
                    labelsCount,
                    labels,
                    labelArray2,
                    dispatch,
                    LabelSession,
                    objetArray,
                    user,
                    userFields,
                    saveUserLocal,
                    searchParams,
                    setObjetArray,
                    setPageName,
                    removeSeperatorValue,
                    TableType,
                    SchemaObject,
                    saveSchemaObjectLocal,
                    labelSessionArray,
                    val2,
                    setIsLoading,
                    navigate,
                    createSearchParams,
                    location,
                    setlabelReference,
                    VIPSDataServiceURL,
                    requestOptions,
                    setPageId,
                    ediReadonlyMode,
                  })
          }
          validateOnBlur={true}
          validate={(values) => {
            const errors = schemaValidation(
              values,
              val,
              mandatoryByLabelName,
              mapTableItemID,
              selectedOption,
              tableItemID,
              selectedTabs,
              csvUplaodEnabled
            );
            // Per-table validation: collect all tables with total zero
            const totals = window.__tableTotals || {};
            const errorTables = [];
            Object.entries(totals).forEach(([tableName, flags]) => {
              if (flags?.hasQty === true && flags?.totalZero === true) {
                errors[`${tableName}_Total_Label`] = getMessage("totalQuantityValidation");
                errorTables.push(tableName);
              }
            });
            // ELC duplicate validation for all array-typed tables
            const tableNames = Object.keys(values || {}).filter((k) => Array.isArray(values[k]));
            tableNames.forEach((tableName) => {
              const res = validateELCNoDuplicates(values, tableName, val || []);
              if (res.hasDuplicates) {
                const elcErrors = buildELCDuplicateErrors(tableName, res);
                // Merge into errors so ErrorMessage components can render immediately
                Object.assign(errors, elcErrors);
              }
            });

            return errors;
          }}
        >
          {!isLoading && searchParams.get("label") && (
            <div style={{ width: "100%", margin: "0 20px" }}>
              <Chip
                label={
                  getMessage("enterVariableData") + searchParams.get("label")
                }
                color="info"
                size="small"
              />
            </div>
          )}
          {!isLoading && searchParams.get("label") && (
            <div style={{ width: "100%", margin: "0 20px" }}>
              {searchParams.get("store_grp") === "TES" && (
                <Button onClick={openPopup}>Upload File</Button>
              )}
            </div>
          )}
          <SchemaNotFoundAlert
            schemaNotFound={schemaNotFound}
            message={getMessage("schemaNotFound")}
          />
          {schemaNotFound && (
            <>
              <br />
              <Alert severity="warning">{getMessage("schemaNotFound")}</Alert>
            </>
          )}
          <DynamicFormElements
            divisionId={divisionId}
            sessionId={searchParams.get("session_id")}
            sessionObjectId={sessionObjectId}
            PageID={searchParams.get("PageID")}
            labelref={searchParams.get("label")}
            prod_loc_occ={prod_loc_occ}
            occ_profile={occ_profile}
            schema_name={schema_name}
            user_id={user_id}
            schema_id={schema_id}
            store_grp={searchParams.get("store_grp")}
            store_grp_desc={searchParams.get("store_grp_desc")}
            vd_mode={searchParams.get("vd_mode")}
            OrderID={searchParams.get("OrderID")}
            OCC={searchParams.get("OCC")}
            handleFileUpload={
              userSelection
                ? () =>
                    handleUpload({
                      file1,
                      file2,
                      setIsLoading,
                      setMapTableItemID,
                      setErrorMessage,
                      setSnackbarMessage,
                      setOpenSnackbar,
                      setUploaded,
                      setCsvData,
                      setCombinedData,
                      setFile1,
                      setFile2,
                      fileInput1Ref,
                      fileInput2Ref,
                      combineCSVData,
                      initForm,
                      regexString,
                      searchParams,
                      schemaData,
                      uniqueProductIds,
                      copyOrderData,
                      labelReference,
                      user_id,
                      setFormData,
                      userSelection,
                      schemaName,
                    })
                : (e) =>
                    handleFileUpload({
                      e,
                      userSelection,
                      setIsLoading,
                      setMapTableItemID,
                      setErrorMessage,
                      setCsvData,
                      setUploaded,
                      initForm,
                      regexString,
                      searchParams,
                      schemaData,
                      uniqueProductIds,
                      copyOrderData,
                      labelReference,
                      user_id,
                      setFormData,
                      schemaName,
                    })
            }
            errorMessage={errorMessage}
            csvUploadEnabled={csvUplaodEnabled}
            values={val}
            user={user}
            selectedOption={selectedOption}
            handleDropdownChange={handleDropdownChange}
            setChildOpt={setChildOpt}
            formData={formData}
            csvData={csvData}
            uploaded={uploaded}
            pageId={pageId}
            pageName={pageName}
            pageSequence={pageSequence}
            childPages={childPages}
            catTabData={catTabData}
            catTabData2={catTabData2}
            tableItemID={tableItemID}
            resetELCList={resetELCList}
            ELLValue={ELLValue}
            setFormData={setFormData}
            setPageChange={setPageChange}
            pageChange={pageChange}
            mandatoryByLabelName={mandatoryByLabelName}
            disableByLabelName={disableByLabelName}
            mapTableItemID={mapTableItemID}
            csvUplaodEnabled={csvUplaodEnabled}
            setCatTabData={setCatTabData}
            setCatTabData2={setCatTabData2}
            handleResetELCList={handleResetELCList}
            handleELLValue={handleELLValue}
            ELLSchemaItem={ELLSchemaItem}
            handleELLVSchemaItem={handleELLVSchemaItem}
            setFile1={setFile1}
            setFile2={setFile2}
            combineCSVData={combineCSVData}
            setUserSelection={setUserSelection}
            userSelection={userSelection}
            multipleCsvUplaodEnabled={multipleCsvUplaodEnabled}
            csvFileNameStartLatters={csvFileNameStartLatters}
            csvFileNameEndWith={csvFileNameEndWith}
            schemaName={schemaName}
                        setSelectedTabs={setSelectedTabs}
            selectedTabs={selectedTabs}
            setMapTableItemID={setMapTableItemID}
            setIsLoading={setIsLoading}
            fileInput1Ref={fileInput1Ref}
            fileInput2Ref={fileInput2Ref}
            val={val}
            searchParams={searchParams}
            tescoFiledMapping={tescoFiledMapping}
            divisionID={divisionID}
            ELCDropDown={ELCDropDown}
            setELCDropDown={setELCDropDown}
            childOpt={childOpt}
            setLLIValue={setLLIValue}
            LLIValue={LLIValue}
            toggleTescoFileUploaded={toggleTescoFileUploaded}
            allow100PercentFibreWithourGarment={
              allow100PercentFibreWithourGarment
            }
            SetcatalogueChildOptn={SetcatalogueChildOptn}
            catalogueChildOptn={catalogueChildOptn}
            ediReadonlyMode={ediReadonlyMode}
            ediEditableFields={ediSchemaConfig?.editableFields || DEFAULT_EDI_EDITABLE_FIELDS}
            showEDIButton={showEDIButton}
            ediSchemaConfig={ediSchemaConfig}
            handleEDIClick={handleEDIClick}
            ediLoading={ediLoading}
            ediTableVisible={ediTableVisible}
            factoryDivisionConfig={factoryDivisionConfig}
          />

          <div
            className=""
            style={{ padding: "15px 0px 0px 15px", float: "left" }}
          >
            <ScrollToErrors />

            <SubmitButton
              title="Next"
              pageSequence={pageSequence}
              pageName={pageSequence}
              childPages={childPages}
              schemaPageFields={val}
              schemaNotFound={schemaNotFound}
              ediLoading={ediLoading}
            />
              {pageSequence === 1 && showCancelButton && (
               <CancelOrderButton
                      prod_loc_occ={prod_loc_occ}
                      occ_profile={occ_profile}
                      schema_name={schema_name}
                      user_id={user_id}
                      schema_id={schema_id}
                       sessionId={searchParams.get("session_id")}
                      sessionObjectId={sessionObjectId}
                      store_grp={searchParams.get("store_grp")}
                      store_grp_desc={searchParams.get("store_grp_desc")}
                      vd_mode={searchParams.get("vd_mode")}
                      OrderID={searchParams.get("OrderID")}
                      OCC={searchParams.get("OCC")}
                      setSelectedTabs ={setSelectedTabs}
                      setUserSelection={setUserSelection}
                      setMapTableItemID={setMapTableItemID}
                        searchParams={searchParams}
                      childPages={childPages} // new: pass childPages
                      ediLoading={ediLoading}
                      />
            )}
          </div>
        </Form>
        <div style={{ marginBottom: 120 }}></div>
      </div>
      <SnackbarAlert
        open={openSnackbar}
        message={snackbarMessage}
        severity="error"
        onClose={handleCloseSnackbar}
      />
    </Grid>
  );
};
export default OEForm;
